import type { ITaskRepository } from "@src/domain/pascos/repository/task_repository";

/**
 * Use Case: Delete Task
 * Deletes a task from the system
 */
export class DeleteTaskUseCase {
    constructor(private readonly taskRepository: ITaskRepository) { }

    /**
     * Execute the use case
     * @param taskId - The unique identifier of the task to delete
     * @returns Promise<void>
     */
    async execute(taskId: string): Promise<void> {
        await this.taskRepository.delete(taskId);
    }
}
